/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { ResolveAdminCreationOrganizationResponse, ResolveAdminCreationOrganizationVars } from '../openapi-types.gen.js';

export type { ResolveAdminCreationOrganizationResponse, ResolveAdminCreationOrganizationVars } from '../openapi-types.gen.js';

export const useResolveAdminCreationOrganization = createMutationHook<ResolveAdminCreationOrganizationVars, ResolveAdminCreationOrganizationResponse, unknown>({
  specName: 'useResolveAdminCreationOrganization',
  path: '/v1/admin/creation-access/organization',
  method: 'POST',
  resolveUrl: (vars: ResolveAdminCreationOrganizationVars) => `/v1/admin/creation-access/organization`,
  buildBody: (vars: ResolveAdminCreationOrganizationVars) => ({ email: vars.email }),
  parseResponse: (raw: unknown): ResolveAdminCreationOrganizationResponse => raw as ResolveAdminCreationOrganizationResponse,
  
  
  
});
